import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '~src/httpClient/RestApiService';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import { IServerUser } from '~src/userManagement/users/serverApi/types/IServerUser';


export function addToIdentityPoolRequestConfig(): JsonRestApiRequestConfig {
  return {
    restApiVersion: '3.18',
    httpMethod: 'POST',
    endpoint: `users/identityPool`,
    serverWideRequest: true
  };
}

interface SystemUserType {
  user: {
    name: string;
    id: string;
    identityPoolUuid: string;
    identityUuid: string;
  };
}

export function callAddToIdentityPoolRequest(serverUser: IServerUser, identityUuid: string, poolId: string): Promise<IResult> {
  return makeJsonRestApiRequest<SystemUserType, IResult>({
    config: addToIdentityPoolRequestConfig(),
    request: {
      user: {
        name: serverUser.username,
        id: serverUser.id,
        identityPoolUuid: poolId,
        identityUuid: identityUuid
      }
    },
  });
}
